// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1DK2u","buttons":"SendReceipts_buttons__29t8K","email":"SendReceipts_email__2WxLW","bookApptTitle":"SendReceipts_bookApptTitle__1nw4i"};